import React from "react";
import { CustIcon } from "../Svgs";
import "./UserAvatar.less";

export const UserAvatar = ({
  src,
  title,
  firstName,
  lastName,
  subtitle,
  size,
  className,
  count,
  border,
  location,
  edit,
  onClick,
  hideName,
}) => {
  const addClassName = className === undefined ? "" : className;
  const sizelength = size === undefined ? "50" : size;
  const Border = border ? "avatarBorder" : "";

  return (
    <div className="d-flex align-items-center profileSec">
      <div
        className={`custAvatar custAvatar-${sizelength} ${addClassName} ${Border} `}
      >
        {src ? (
          <img src={src} alt="" />
        ) : firstName || lastName ? (
          <span>
            {firstName?.charAt(0).toUpperCase()}
            {lastName?.charAt(0).toUpperCase()}
          </span>
        ) : (
          <img
            src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png"
            alt=""
          />
        )}
        {count ? (
          <div className="count">{count}</div>
        ) : edit ? (
          <div className="edit">
            <CustIcon type="edit" className="mr-1" />
          </div>
        ) : null}
      </div>
      <div className="d-flex flex-column">
        {(firstName || lastName) && !hideName && (
          <strong className="profileTop  pl-3">{`${firstName} ${lastName}`}</strong>
        )}
        {subtitle ? (
          <div className="profileBottom  pl-3">{subtitle}</div>
        ) : location ? (
          <div className="d-flex align-items-center location  pl-3">
            <CustIcon type="location" className="mr-1" />
            <span>{location}</span>
          </div>
        ) : null}
      </div>
    </div>
  );
};
